import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import TouchableElement from '@components/common/touchableElement';
import ColorWrapper from '@styles/colors';

import { ColorFunction } from '@styles/colors/types';
import { scaleOP } from '@components/frame';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { fontOP } from '@styles/fonts';
import { SimpleOnPress } from '@interfaces/base';

interface EmptyScreenProps extends SimpleOnPress {
  C: ColorFunction;
}

const EmptyScreen: React.FC<EmptyScreenProps> = ({ C, onPress }) => {
  return (
    <View
      style={{
        flex: 1,
        width: '100%',
        height: '100%',
        paddingHorizontal: scaleOP(18),
        paddingBottom: scaleOP(18),
        backgroundColor: C('Background/Light/Panel [mobile]'),
      }}
    >
      <TouchableElement
        testID={TEST_IDS.operatorPanel.information.notes.emptyScreen}
        onPress={onPress}
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        {({ boxStyle }) => {
          return (
            <View
              style={[
                boxStyle,
                {
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: C('Background/Light/Field on Panel [mobile]'),
                  borderRadius: scaleOP(SCREEN_BORDER_RADIUS),
                },
              ]}
            >
              <Text
                style={[
                  fontOP['Body'],
                  {
                    color: C('Label/Light/Tertiary'),
                  },
                ]}
              >
                {i18n.t('Click to create a note')}
              </Text>
            </View>
          );
        }}
      </TouchableElement>
    </View>
  );
};

export default ColorWrapper(EmptyScreen);
